import { cn } from '../../utils/cn';

interface EventPriorityBadgeProps {
  priority: number;
  size?: 'sm' | 'md';
  className?: string;
}

const getPriorityConfig = (priority: number) => {
  if (priority >= 1 && priority <= 3) {
    return {
      bg: 'bg-red-500/15',
      text: 'text-red-300',
      border: 'border-red-500/25',
      label: 'Critical',
    };
  }
  if (priority >= 4 && priority <= 5) {
    return {
      bg: 'bg-orange-500/15',
      text: 'text-orange-300',
      border: 'border-orange-500/25',
      label: 'High',
    };
  }
  if (priority >= 6 && priority <= 7) {
    return {
      bg: 'bg-amber-500/15',
      text: 'text-amber-300',
      border: 'border-amber-500/25',
      label: 'Medium',
    };
  }
  return {
    bg: 'bg-green-500/15',
    text: 'text-green-300',
    border: 'border-green-500/25',
    label: 'Low',
  };
};

export const EventPriorityBadge = ({ priority, size = 'sm', className }: EventPriorityBadgeProps) => {
  const config = getPriorityConfig(priority);

  return (
    <span
      className={cn(
        'badge',
        config.bg,
        config.text,
        config.border,
        size === 'md' && 'text-xs px-2.5 py-1',
        className,
      )}
      title={`Priority: ${priority}/10 (${config.label})`}
    >
      P{priority}
    </span>
  );
};
